import { DishForTree, PartialMenuItem } from "../../../../../interfaces/meMenuInterfaces/interfaces";

export const mapDishesFromBackendToTreeDishes = (backendDishes: PartialMenuItem[]): DishForTree[] => {
    const result: DishForTree[] = [];

    backendDishes?.forEach((dish) => {
        const { id: dishId, name: dishName, nameOrigin: dishNameOrigin, categories } = dish;

        categories?.forEach((cat) => {
            if (cat.parentCategory) {
                const main = cat.parentCategory;

                result.push({
                    id: dishId,
                    name: dishName,
                    nameOrigin: dishNameOrigin ?? null,
                    categoryId: main.id,
                    categoryName: main.name,
                    subcategoryId: cat.id,
                    subcategoryName: cat.name,
                });
            } else {
                result.push({
                    id: dishId,
                    name: dishName,
                    nameOrigin: dishNameOrigin ?? null,
                    categoryId: cat.id,
                    categoryName: cat.name,
                });
            }
        });
    });

    return result;
};
